/* eslint-disable eqeqeq */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex, useToast } from "@chakra-ui/react";
import { FaEdit, FaTrash } from "react-icons/fa";

import { Link } from "react-router-dom";
import NotificationsFilterBar from "../../components/notifications/filter-bar";
import Loader from "../../components/PageLoader";
import { Paths } from "../../routes/paths";
import {
  useGetNotificationsPaginated,
  useDeleteNotification,
} from "../../services/notifications";
import { initialDataState } from "./constants";
import * as XLSX from "xlsx";
import BreadCrumb from "components/breadCrumb";

export default function NotificationsList() {
  const toast = useToast();
  const [notifications, setNotifications] = useState([]);
  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;

  const [filters, setFilters] = useState({ searchCriteria: "" });

  const {
    mutate: getNotifications,
    isSuccess,
    data,
    isPending,
    reset,
  } = useGetNotificationsPaginated();

  const { mutate: deleteNotification } = useDeleteNotification();

  useEffect(() => {
    if (isSuccess && Array.isArray(data?.data)) {
      setNotifications(data.data);
      setTotalRecords(data.data.length);
      reset();
    }
  }, [isSuccess, data]);

  useEffect(() => {
    setCurrentPage(1);
    fetchList(1);
  }, [filters]);

  const fetchList = (page) => {
    getNotifications({
      pageNumber: page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
    });
  };

  const handleExport = async () => {
    getNotifications(
      {
        pageNumber: 1,
        pageRowCount: 10000, // sufficiently large to fetch all
        searchCriteria: filters.searchCriteria,
      },
      {
        onSuccess: (res) => {
          const rows = res?.data || [];
          if (!rows.length) {
            toast({
              title: "No data found",
              description: "No notifications exist for the selected filters",
              status: "info",
              isClosable: true,
            });
            return;
          }

          const excelRows = rows.map((item) => ({
            ID: item.id,
            Type: item.eventCategory,
            Description: item.description,
            WhenSent: item.whenSent || "-",
            Threshold:
              item.threshold != null
                ? `${item.threshold}${
                    item.thresholdType === "PercentageElapsed"
                      ? "%"
                      : " minutes"
                  }`
                : "-",
            Region: item.regions?.join(", ") || "-",
            Level: item.escalationLevel?.join(", ") || "-",
            ActivityTypes: item.activities?.join(", ") || "-",
            AssignmentGroups: item.assignmentGroups?.join(", ") || "-",
            Customer: item.customerNames || "All",
            NotificationChannel: item.notificationChannels?.join(", ") || "-",
            Status: item.isActive ? "Active" : "Inactive",
          }));

          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.json_to_sheet(excelRows);

          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Notification Rules",
          );

          XLSX.writeFile(workbook, "Notification_Rules.xlsx");

          toast({
            title: "Export successful",
            status: "success",
            isClosable: true,
          });
        },
        onError: (err) => {
          toast({
            title: "Export failed",
            description: err.message || "Something went wrong",
            status: "error",
            isClosable: true,
          });
        },
      },
    );
  };

  const onPageChange = (e) => {
    const page = e.page.skip / pageSize + 1;
    setCurrentPage(page);
    fetchList(page);
  };

  // const canEdit = useMemo(
  //   () => HasPermission(user, "NotificationRule", "Edit"),
  //   [user]
  // );

  const handleDelete = (id) => {
    deleteNotification(id, {
      onSuccess: () => {
        setNotifications((prev) => prev.filter((item) => item.id !== id));
        toast({
          title: "Notification Rule deleted successfully",
          status: "success",
          isClosable: true,
        });
        fetchList(currentPage);
      },
      onError: (err) => {
        toast({
          title: "Failed to delete notification Rule",
          description: err.message || "Something went wrong",
          status: "error",
          isClosable: true,
        });
      },
    });
  };
  // -------------------- Action Cell Constants --------------------
  const editCell = (dataItem) => (
    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
      <Link to={`${Paths.editNotification}/${dataItem.id}`}>
        <FaEdit color="var(--primary-dark)" size={16} />
      </Link>
    </td>
  );

  const deleteCell = (dataItem) => (
    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
      <button
        type="button"
        onClick={() => handleDelete(dataItem.id)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 2,
        }}
      >
        <FaTrash color="red" size={16} />
      </button>
    </td>
  );
  return (
    <Flex className="main-container" direction="column">
      {isPending ? <Loader /> : null}
      <Flex px="20px">
        <BreadCrumb
          links={[
            { text: "Dashboard", link: Paths.dashboard },
            { text: "Notification Rules", isCurrentPage: true },
          ]}
        />
      </Flex>
      <Card m="20px">
        <CardBody>
          <NotificationsFilterBar
            getList={(search) => setFilters({ searchCriteria: search })}
            onExport={handleExport}
          />

          <Grid
            data={process(notifications || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => setDataState(e.dataState)}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column field="eventCategory" title="Type" width={120} />
            <Column field="description" title="Description" width={240} />
            {/* <Column
              field="whenSent"
              title="When Sent"
              width={140}
              cell={({ dataItem }) => <td>{dataItem.whenSent || "-"}</td>}
            /> */}
            <Column
              title="Notification Type"
              field="notificationType"
              width={180}
            />
            <Column
              title="Threshold / Interval"
              width={170}
              cell={({ dataItem }) => (
                <td>
                  {dataItem.threshold ?? "-"}
                  {dataItem.threshold != null
                    ? dataItem.thresholdType === "PercentageElapsed"
                      ? "%"
                      : " minutes"
                    : ""}
                </td>
              )}
            />
            <Column
              title="Region"
              width={160}
              cell={({ dataItem }) => (
                <td>{dataItem.regions?.join(", ") || "-"}</td>
              )}
            />
            <Column
              title="Level"
              width={100}
              cell={({ dataItem }) => (
                <td>{dataItem.escalationLevel?.join(", ") || "-"}</td>
              )}
            />
            <Column
              title="Activity Type"
              width={180}
              cell={({ dataItem }) => (
                <td>{dataItem.activities?.join(", ") || "-"}</td>
              )}
            />
            <Column
              title="Customer"
              width={200}
              cell={({ dataItem }) => (
                <td>{dataItem.customerNames || "All"}</td>
              )}
            />
            <Column
              title="Notification Channel"
              width={180}
              cell={({ dataItem }) => (
                <td>{dataItem.notificationChannels?.join(", ") || "-"}</td>
              )}
            />
            <Column
              title="Status"
              width={100}
              cell={({ dataItem }) => (
                <td>{dataItem.isActive ? "Active" : "Inactive"}</td>
              )}
            />
            {/* Action Columns */}
            <Column
              title="Edit"
              width={80}
              className="text-center"
              headerClassName="text-center"
              cell={({ dataItem }) => editCell(dataItem)}
            />
            <Column
              title="Delete"
              width={80}
              className="text-center"
              headerClassName="text-center"
              cell={({ dataItem }) => deleteCell(dataItem)}
            />
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
